export class PersonalFileInfo {
  fileName!: string;
  fileBytes!: number;
  fileDate!: Date;
  isNew!: boolean;

  isChecked!: boolean;
}
